<template>
  <div
    id="panel"
    class="panel"
  >
    <div class="panel-title">
      <p>实验成绩管理</p>
    </div>
    <div class="panel-content center_content">
      <div class="course_info">
        <div class="panel-title">
          <p v-if="lessonInfo">{{ lessonInfo ? lessonInfo.title : '' }}</p>
          <p v-if="lessonInfo">负责人:{{  lessonInfo.manager &&  lessonInfo.manager ? lessonInfo.manager.name : '' }}</p>
        </div>
        <div class="course_btn">
          <div v-show="false"></div>
        </div>
      </div>
      <div id="list">
        <table>
          <tbody>
          <tr class="l_header">
            <th class="itemStatus">姓名</th>
            <th class="itemStatus">实验结果</th>
            <th class="itemStatus">实验成绩</th>
            <th class="itemStatus">实验开始时间</th>
            <th class="itemStatus">实验结束时间</th>
            <th class="itemStatus">实验用时</th>
            <th class="itemStatus">操作</th>
          </tr>
          <tr
            class="item"
            v-for="item in tableData"
            :key="item.id"
          >
            <td class="itemStatus">{{item.name}}</td>
            <td class="itemStatus">{{item.status==1?'完成':'未完成'}}</td>
            <td class="itemStatus">{{item.score}}</td>
            <td class="itemStatus">{{formatTime(item.startTime)}}</td>
            <td class="itemStatus">{{formatTime(item.endTime)}}</td>
            <td class="itemStatus">{{secondsToMinute(item.timeUsed)}}</td>
            <td class="itemStatus">
              <a
                class="edit"
                href="javascript:;"
                @click="viewDetail(item)"
              >查看详情</a>
              <br>
              <a
                v-if="item.reportStatus == 1"
                class="edit"
                href="javascript:;"
                @click="downloadReport(item)"
              >下载报告</a>
              <a
                v-if="item.reportStatus != 1"
                class="edit"
                style="color: #aaaaaa"
                href="javascript:;"
              >下载报告</a>
            </td>
          </tr>
          </tbody>
        </table>
        <div
          class="noitems"
          v-if="false"
        >没有数据</div>
      </div>
    </div>
    <div
      class="form_overlay"
      :style="classShowDetailWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel form_panel_item">
        <div class="form_title">详情
          <span @click="classShowDetailWindow={}">X</span>
        </div>
        <div class="form_content">
          <div class="experiment_text">
            <p>姓名：{{ experimentGrade && experimentGrade.experimentStudent ? experimentGrade.experimentStudent.userprofile.name : '' }}</p>
            <p><span>实验开始时间：{{ formatTime(experimentGrade.startTime) }}</span>
              <span>实验结束时间：{{ formatTime(experimentGrade.endTime) }}</span>
              <span>实验用时：{{ secondsToMinute(experimentGrade.timeUsed) }}</span>
            </p>
            <p><span>实验满分：100</span>
              <span>实验得分：{{ experimentGrade.score }}</span>
              <span>实验结果：{{ experimentGrade.status ? '完成' : '未完成' }}</span>
            </p>
          </div>
          <div class="f_list">
            <table>
              <tbody>
              <tr class="l_header">
                <th class="itemStatus">步骤名称</th>
                <th class="itemStatus">步骤开始时间</th>
                <th class="itemStatus">步骤结束时间</th>
                <th class="itemStatus">步骤用时</th>
                <th class="itemStatus">步骤合理用时</th>
                <th class="itemStatus">步骤满分</th>
                <th class="itemStatus">步骤得分</th>
                <th class="itemStatus">步骤操作次数</th>
                <th class="itemStatus">步骤评价</th>
                <th class="itemStatus">赋分模型</th>
                <th class="itemStatus">备注</th>
              </tr>
              <tr
                v-for="item in tableStepData"
                :key="item.id"
              >
                <td class="itemStatus">{{ item.title }}</td>
                <td class="itemStatus">{{ formatTime(item.startTime) }}</td>
                <td class="itemStatus">{{ formatTime(item.endTime) }}</td>
                <td class="itemStatus">{{ secondsToMinute(item.timeUsed) }}分钟</td>
                <td class="itemStatus">{{ secondsToMinute(item.expectTime) }}分钟</td>
                <td class="itemStatus">{{ item.maxScore }}</td>
                <td class="itemStatus">{{ item.score }}</td>
                <td class="itemStatus">{{ item.repeatCount }}</td>
                <td class="itemStatus">{{ item.evaluation }}</td>
                <td class="itemStatus">{{ item.scoringModel }}</td>
                <td class="itemStatus">{{ item.remarks }}</td>
              </tr>
              <tr
                class="noitems"
                v-if="!tableStepData.length"
              >
                <td colspan="11">没有数据</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="f_list" v-if="experimentGrade.remarks" v-html="experimentGrade.remarks"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OnlineExperimentGrade',
  props: [
    'lessonInfo'
  ],
  data () {
    return {
      queryInfo: {
        page: 1,
        size: 1000,
        lessonOnline_id: 0
      },
      tableData: [],
      tableDataCount: 0,
      experimentGrade: {},
      classShowDetailWindow: {},
      tableStepData: []
    }
  },
  methods: {
    secondsToMinute(s) {
      if (!s) {
        return 0
      }
      return Math.ceil(s / 60)
    },
    formatTime(val) {
      return val ? val.replace('T', ' ') : '--'
    },
    async search() {
      this.queryInfo.userprofile_id = this.localUser.profile_id
      await this.$http.get('/lesson_experiment_grade/', {
        params: this.queryInfo
      }).then((data) => {
        console.log(data)
        if (data.code === '200') {
          this.tableData = data.data.results
          this.tableDataCount = data.data.count
        } else {
          this.$layer.msg('查询失败')
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    getTimeUsed (t1, t2) {
      const ts1 = new Date(t1).getTime()
      const ts2 = new Date(t2).getTime()
      const allTime = (ts2 - ts1) / 1000

      const h = Math.floor(allTime / 3600)
      const m = Math.floor((allTime - h * 3600) / 60)
      const s = allTime - 3600 * h - 60 * m

      let res = ''
      if (h > 0) {
        res += h + '小时'
      }
      if (m > 0) {
        res += m + '分钟'
      }
      if (s > 0) {
        res += s + '秒'
      }
      return res
    },
    async viewDetail(item) {
      item.startTime = item.startTime.replace('T', ' ')
      item.endTime = item.endTime.replace('T', ' ')
      this.experimentGrade = item
      this.classShowDetailWindow = {
        visibility: 'visible'
      }
      const params = {
        page: 1,
        size: 10000,
        experimentGrade_id: item.id
      }

      await this.$http.get('/allowany/experimentstep/', {
        params: params
      }).then((data) => {
        this.tableStepData = data.results
      }).catch(() => {
        this.$layer.msg('获取成绩信息失败！')
      })
    },
    downloadReport(item) {
      console.log(JSON.parse(item.experimentReport))
      window.open(JSON.parse(item.experimentReport).path)
    }
  },
  created () {
    this.queryInfo.lessonOnline_id = this.lessonInfo.id
    this.search()
  },
  computed: {
    localUser() {
      return this.$store.state.userInfo
    }
  }
}
</script>

<style lang="less" scoped>
.form_title {
  position: relative;
}
.form_title span {
  position: absolute;
  right: 0;
  top: 0;
  background: #ff8383 repeat scroll 0 0;
  color: #ff8383;
  cursor: pointer;
  height: 30px;
  line-height: 28px;
  text-align: center;
  width: 30px;
  font-size: 24px;
  border-radius: 3px;
  overflow: hidden;
}
.form_title span::before {
  content: "×";
  display: block;
  width: 30px;
  height: 30px;
  font-family: 宋体;
  color: rgb(255, 255, 255);
}
.tips {
  clear: both;
  color: #999;
}
.form_panel_item {
  width: 1200px;
  max-width: none;
  margin: 0;
  transform: translate(-50%, -50%);
}
.f_list .l_header th {
  padding: 15px 0;
}
.experiment_text {
  margin-bottom: 20px;
}
.experiment_text p {
  line-height: 3;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.experiment_text p span {
  flex: 1;
}
.form_title {
  position: relative;
}
.form_title span {
  position: absolute;
  right: 0;
  top: 0;
  color: #999;
  font-weight: normal;
  cursor: pointer;
}
.course_info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  .panel-title {
    p {
      display: inline-block;
      margin-right: 20px;

      &:last-child {
        color: #999;
        font-size: 16px;
      }
    }
  }
  .course_btn {
    div {
      margin-left: 20px;
      padding: 7px 20px;
      background: #73D6CA;
      color: #fff;
      border-radius: 3px;
      &:first-child {
        background: #25c7a8;
      }
      &:nth-child(2) {
        border: 1px solid #73D6CA;
        color: #73D6CA;
        background: #fff;
      }
    }
  }
}
.panel-content {
  padding: 20px 40px;
}
</style>
